import cleanentityprefix from '@/common/dataFilters/cleanEntityPrefix'

const DIRTY_KEYS = ['external_id', 'name', 'reference_code', 'id', 'courier_company_id', 'company_id', 'external_code', 'external_order_id']

export const sanitizeModel = (model) => {
  if (!model.fields) return model

  model.fields = model.fields.map(field => {
    // 1. Wrap Formatter for ALL fields (any formatter can output entity data in HTML)
    if (field.formatter || DIRTY_KEYS.includes(field.key)) {
      const originalFormatter = field.formatter
      field.formatter = (value, key, item) => {
        const result = originalFormatter ? originalFormatter(value, key, item) : value
        if (typeof result === 'string') {
          // Clean prefixes but preserve HTML structure if present
          return result.split(/(<[^>]*>)/).map(part => {
            return part.startsWith('<') ? part : cleanentityprefix(part)
          }).join('')
        }
        return result
      }
    }

    // 2. Wrap componentEdit / component props (preQuery sanitization) for ALL fields
    if (field.componentEdit || field.component) {
      const wrapComp = (compFn) => (value, key, item) => {
        const comp = compFn(value, key, item)
        if (comp.props && comp.props.preQuery) {
          comp.props.preQuery = cleanentityprefix(comp.props.preQuery)
        }
        return comp
      }
      if (field.component) field.component = wrapComp(field.component)
      if (field.componentEdit) field.componentEdit = wrapComp(field.componentEdit)
    }

    return field
  })

  return model
}
